/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import axios from 'axios'
import toast from 'react-hot-toast'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {BASE_URL} = import.meta.env

const AppRoutes: FC = () => {
  const currentUser = useAuth()
  // const {currentUser} = useAuth()
  const {saveAuth, setCurrentUser} = useAuth()
  const isAuthRoute = location.pathname.startsWith("/auth");

  axios.interceptors.response.use(
    (response) => response,
  
    async (error) => {
      if (error?.response?.status === 401) {
        saveAuth(undefined)
        setCurrentUser(undefined)

        if (!isAuthRoute) {
          if (!sessionStorage.getItem('unauthenticated-toast-shown')) {
            sessionStorage.setItem('unauthenticated-toast-shown', 'true')
            toast.error(error?.response?.data?.message)
  
            // Reset the flag after a short delay
            setTimeout(() => {
              sessionStorage.removeItem('unauthenticated-toast-shown')
            }, 3000) // Adjust delay as needed
          }
        }
      }
      return Promise.reject(error)
    }
  )

  return (
    <BrowserRouter basename={BASE_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {currentUser?.auth ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/planner' />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
